/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Provider } from "react-redux";
import { ShopTheLookCarousel } from "~/common/Store/models/Brand";
import ExpandedProductCarouselMember from "./ExpandedProductCarouselMember";
import "./productCarousel.scss";
import Store from "~/common/Store";

interface Props {
  carousel: ShopTheLookCarousel;
  carouselIndex: number;
  visible: boolean;
}
const ExpandedShopTheLookCarousel = ({
  carousel,
  carouselIndex,
  visible,
}: Props) => {
  const hideCarousel = visible ? "" : "hide";

  return (
    <Provider store={Store}>
      <div
        id={`shopTheLookProductCarouselContainer${carouselIndex}`}
        data-component="shopLookProductCarousel"
        className={hideCarousel}
      >
        <div className="carousel-wrap">
          <div className="clearfix">
            <div className="carousel-wrap__header">
              <h3>Products In This Look!</h3>
            </div>
          </div>
          <div
            data-component="products-in-this-look-carousel"
            id="you-may-also-need"
            className="carousel-wrap"
          >
            <div
              id={`shopTheLookProductCarousel${carouselIndex}`}
              className=" carousel-box"
              data-component="carousel"
              data-testid="shopTheLookCarousel"
              data-feature-name="Shop the Look"
              data-gtm-component="carousel"
              gtm-carousel-name="Shop the Look"
            >
              <div className="ag-carousel-nav">
                <a className="ag-car-prev" data-control="prev" />
                <a className="ag-car-next" data-control="next" />
              </div>
              <div id="otherProductsCarousel" className="ag-carousel-frame box">
                <ul className="ag-carousel ag-mini" data-slide-width="220">
                  {carousel.products.map((product, index) => (
                    <ExpandedProductCarouselMember
                      product={product}
                      index={index}
                      key={index}
                      isTopProductsMember={false}
                    />
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Provider>
  );
};

export default ExpandedShopTheLookCarousel;
